import { render, staticRenderFns } from "./card-json.vue?vue&type=template&id=b249394c&scoped=true"
import script from "./card-json.vue?vue&type=script&lang=js"
export * from "./card-json.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b249394c",
  null
  
)

export default component.exports